import { AlertCircle, ChevronDown, ChevronRight, CreditCard, FileText, Home, Leaf } from "lucide-react";
import { DARK } from "@/components/portal/DocCards";
import { sendTitle, sendWhy } from "@/components/portal/copy";

// Precisa de si (por prioridade) / em análise (inclui o que o consultor trata) / já enviado.
const RANK = { titular: 0, problema: 0, pedido: 1, falta: 1 };
export function splitDocs(docs) {
  const needs = [], review = [], done = [];
  docs.forEach((d) => {
    if (d.state === "ok") done.push(d);
    else if (d.state === "a_verificar" || d.owner_claimed || d.consultant_handles) review.push(d);
    else needs.push(d);
  });
  needs.sort((a, b) => (RANK[a.state] ?? 2) - (RANK[b.state] ?? 2) || Number(!!a.later) - Number(!!b.later));
  return { needs, review, done };
}

const MAX = 3;
const ICONS = [[/^caderneta/, Home], [/^certificado_energetico/, Leaf], [/^(id_|cc_)/, CreditCard]];
const iconOf = (d) => (d.state === "problema" || d.state === "titular" ? AlertCircle : (ICONS.find(([re]) => re.test(d.key)) || [null, FileText])[1]);

export function NowRow({ icon: Icon, title, why, cta, onClick, testid, tone = "" }) {
  return (
    <div className={`flex items-center gap-3 bg-white rounded-xl border border-slate-100 shadow-[0_2px_10px_rgb(0,0,0,0.04)] p-3 ${tone}`} data-testid={testid}>
      <span className="w-11 h-11 rounded-full grid place-items-center shrink-0 brand-soft brand-text"><Icon size={20} /></span>
      <div className="flex-1 min-w-0">
        <div className="text-[15px] font-semibold text-slate-900 leading-snug">{title}</div>
        {why && <div className="text-[13px] text-slate-500 leading-snug mt-0.5">{why}</div>}
      </div>
      {cta ? (
        <button type="button" onClick={onClick} className="shrink-0 h-10 px-4 rounded-lg text-sm font-semibold text-white transition-opacity hover:opacity-90" style={DARK} data-testid={`${testid}-go`}>{cta}</button>
      ) : (
        <button type="button" onClick={onClick} aria-label="Abrir" className="shrink-0 w-10 h-10 rounded-full grid place-items-center text-white" style={DARK} data-testid={`${testid}-go`}><ChevronRight size={18} /></button>
      )}
    </div>
  );
}

const docRow = (d, ctx, why, onOpen) => (
  <NowRow key={d.key} icon={iconOf(d)} title={sendTitle(d)} why={d.state === "titular" ? `Está em nome de ${d.owner_name}.` : d.todo || sendWhy(d, ctx, why)}
    cta={d.state === "titular" ? "Confirmar" : "Enviar"} onClick={() => onOpen(d.key)} testid={`portal-now-item-${d.key}`} />
);

// Só as ações prioritárias; cada «Enviar» abre o ecrã desse documento.
export function WhatNeedsYouNow({ needs, top = null, ctx, why, onOpen, more, setMore }) {
  if (!needs.length && !top) return null;
  const first = needs.slice(0, MAX);
  const rest = needs.slice(MAX);
  return (
    <section data-testid="portal-now">
      <h2 className="flex items-center gap-2 font-heading text-xl brand-text leading-tight">
        <span className="w-6 h-6 rounded-full grid place-items-center text-white text-sm font-bold shrink-0" style={DARK}>!</span>
        O que precisa de si agora
      </h2>
      {top && <div className="mt-3">{top}</div>}
      {first.length > 0 && <div className="mt-3 space-y-2.5" data-testid="portal-now-list">{first.map((d) => docRow(d, ctx, why, onOpen))}</div>}
      {rest.length > 0 && (
        <div className="mt-2.5" data-testid="portal-now-rest">
          <button type="button" onClick={() => setMore(!more)} aria-expanded={more} className="w-full flex items-center gap-2 px-1 py-2 text-left text-sm font-semibold brand-text" data-testid="portal-now-rest-toggle">
            <span className="flex-1">Depois disto, mais {rest.length} {rest.length === 1 ? "documento" : "documentos"}</span>
            <ChevronDown size={18} className={`text-slate-400 transition-transform ${more ? "rotate-180" : ""}`} />
          </button>
          {more && <div className="mt-1 space-y-2.5">{rest.map((d) => docRow(d, ctx, why, onOpen))}</div>}
        </div>
      )}
    </section>
  );
}
